module.exports = __webpack_public_path__ + "img/botonWhatsapp.1c90cb2b.jpg";